import {ref} from 'vue';
import {storeToRefs} from 'pinia';
import {useTranslation} from '#imports';
import {pushVJoySnackbar} from '@maltjoy/core-vue';
import {useProjectInformationStore} from '~/common/stores';

const isRenewalDialogVisible = ref(false);

export function useRenewProject() {
    const {t} = useTranslation();
    const projectInformationStore = useProjectInformationStore();
    const {projectInformation, renewingProject, dismissingProjectRenewal} = storeToRefs(projectInformationStore);

    function openRenewalDrawer() {
        isRenewalDialogVisible.value = true;
    }

    function closeRenewalDrawer() {
        isRenewalDialogVisible.value = false;
    }

    function handleRenewal() {
        openRenewalDrawer();
    }

    async function handleOptOut(comment?: string) {
        const projectId = projectInformation.value?.projectId;

        try {
            await projectInformationStore.dismissProjectRenewal(projectId, comment);
            pushVJoySnackbar({
                props: {
                    header: t('projectclient.projectview.activity.pending.actions.RENEW_PROJECT.action.secondary.notification.header'),
                    message: t('projectclient.projectview.activity.pending.actions.RENEW_PROJECT.action.secondary.notification.message'),
                    level: 'info',
                },
            });
        } catch {}
    }

    return {
        handleOptOut,
        handleRenewal,
        renewingProject,
        dismissingProjectRenewal,
        isRenewalDialogVisible,
        openRenewalDrawer,
        closeRenewalDrawer,
    };
}
